import React from 'react'

export default function Checkbox({label, id, ...props}) {
  return (
    <div><input type="checkbox" id={id} {...props} /> <label htmlFor={id}>{label}</label></div>
  );
}
